import React from "react";
import { Link } from "react-router-dom";
import me from "../../assets/img/profile_headshot.webp";
import pd from "../../assets/resume/Kunal M Karnik.pdf";
import Services from "../Services";
import Skills from "../Skills";
import { FaHandPointDown } from "react-icons/fa";

const AboutInfo = (props) => {
  return (
    <div>
      <section id="about" className="about">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>About</h2>
            <p>Let me introduce myself</p>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <img src={me} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-8 pt-4 pt-lg-0 content">
              <h3>Hi, I'm Kunal Karnik.</h3>
              <h2>A Software Professional based in India.</h2>
              <p>
                I love taking on new challenges. Software development is
                something that I like from heart as problem solving and logic
                building is something that I am really good at. I’m a software
                developer who genuinely thrives on building mobile apps and
                software from scratch. I love diving into new challenges and
                learning every day. Right now, I’m putting that passion into
                practice at Biz4Solutions in Pune, India.
              </p>
              <p>
                I’m an avid traveller and a music lover. I spend my leisure time
                playing flute or with my camera.
              </p>
              <p>
                Wanna know more? A more detailed look at my professional
                capabilities and experience is available below.
              </p>
              <p style={{ color: "#eebd73", marginBottom: "100px" }}>
                Scroll Down!
                <FaHandPointDown />
              </p>
              <a
                target="_blank"
                rel="noreferrer"
                href={pd}
                className="button uppercase"
              >
                Download Resume
              </a>
              <Link href className="button uppercase" to="/contact">
                Contact Me
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Skills />
      <Services />
    </div>
  );
};

export default AboutInfo;
